import { GlDropdownItem } from '@gitlab/ui';
import { MountingPortal } from 'portal-vue';
import { s__ } from '~/locale';
import AbuseCategorySelector from '~/abuse_reports/components/abuse_category_selector.vue';
export default {
    name: 'ReportAbuseDropdownItem',
    components: {
        GlDropdownItem,
        MountingPortal,
        AbuseCategorySelector
    },
    inject: [
        'reportedUserId',
        'reportedFromUrl'
    ],
    i18n: {
        reportAbuse: s__('ReportAbuse|Report abuse')
    },
    data () {
        return {
            open: false
        };
    },
    methods: {
        toggleDrawer (open) {
            this.open = open;
        }
    }
};
